import React, { useMemo } from 'react';
import {
  Card, Form, Row, Col, Button, Alert,
} from 'react-bootstrap';
import { Fab, Action } from 'react-tiny-fab';

import 'react-tiny-fab/dist/styles.css';
import { mBStyles, tableIcons } from '../../../helpers';

import DownloadLink from '../../../components/common/DownloadLink';

export default function ButtonsCard({
  can, portfId, onEdit, onEditCurrent, onSendHeadSP, onSendExperts, onReturnForRevisionHead, onReturnForRevisionExpert, onApproveFinal,
}) {
  return (
    <Fab event="click" mainButtonStyles={mBStyles}>
      <Card>
        <Card.Body>
          <Form.Group as={Col}>
            {/* { can.Edit && <Button className="me-2" variant="outline-secondary" onClick={() => onEdit()}>Редактировать</Button> } */}
            {/* { can.EditCurrent && <Button className="me-2" variant="outline-secondary" onClick={onEditCurrent}>Внести изменения в текущую версию</Button> } */}
            {/* { can.SendToHead && <Button className="me-2" variant="outline-warning" onClick={onSendHeadSP}>Отправить руководителю СП</Button> } */}
            {/* { can.HeadSendToExperts && <Button className="me-2" variant="outline-warning" onClick={onSendExperts}>Отправить на ЭГ</Button> } */}
            {/* { can.HeadReturn && <Button className="me-2" variant="outline-danger" onClick={onReturnForRevisionHead}>Вернуть на доработку</Button>} */}
            {/* { can.ExpertsReturn && <Button className="me-2" variant="outline-danger" onClick={onReturnForRevisionExpert}>Вернуть на доработку</Button>} */}
            {/* { can.ApproveFinal && <Button className="me-2" variant="success" onClick={onApproveFinal}>Подписанный скан ЦП</Button> } */}
            <DownloadLink variant="outline-secondary" url={`/portfolios/${portfId}/print`} filename={`паспорт-портфеля-${portfId}.pdf`}>Сформировать PDF</DownloadLink>
          </Form.Group>
        </Card.Body>
      </Card>
    </Fab>
  );
}
